import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import React from 'react'
import AppIcon from './AppIcon'
import { previewColors, singleLineClamp } from './previewTheme'
import type { PreviewContent } from './types'

const CARD_RADIUS = '16px'
const CARD_PADDING = '12px'
const ICON_SIZE = '28px'
const ICON_RADIUS = '7px'
const ROW_GAP = '10px'

export interface IosPushCardProps {
  content: PreviewContent
  // The merchant's uploaded logo; falls back to the brand-red placeholder
  // square when omitted (no logo uploaded).
  appIconUrl?: string
}

// iOS push notification: a translucent dark banner on the lock-screen wallpaper,
// using the merchant Text components (off-theme literals annotated in
// previewTheme — OS chrome). The {location_name} token renders literally.
const IosPushCard = ({ content, appIconUrl }: IosPushCardProps) => {
  const [css] = useStyletron()
  return (
    <div
      className={css({
        display: 'flex',
        gap: ROW_GAP,
        alignItems: 'flex-start',
        borderRadius: CARD_RADIUS,
        padding: CARD_PADDING,
        backgroundColor: previewColors.iosPushBackground,
        border: `1px solid ${previewColors.iosPushBorder}`,
      })}
    >
      <AppIcon appIconUrl={appIconUrl} size={ICON_SIZE} radius={ICON_RADIUS} />
      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minWidth: 0,
        })}
      >
        {/* Wrapper divs carry the native `title` tooltip so a merchant can
            still inspect the full text behind the ellipsis (Text doesn't
            forward arbitrary HTML attributes). */}
        <div title={content.title}>
          <Text.BodyText4
            bold
            color="white"
            className={css({ display: 'block', ...singleLineClamp })}
          >
            {content.title}
          </Text.BodyText4>
        </div>
        {/* Collapsed notification truncates the body to a single line,
            matching AndroidPushCard's collapsed treatment. */}
        <div title={content.pushText}>
          <Text.BodyText5
            color="white"
            className={css({ display: 'block', ...singleLineClamp })}
          >
            {content.pushText}
          </Text.BodyText5>
        </div>
      </div>
    </div>
  )
}

export default IosPushCard
